import PropTypes from 'prop-types'
import React from 'react'

import { H4Styled } from './styles'

import './SSpySection.scss'

const SSpySection = React.forwardRef((props, ref) => {
  const { title, children, isActive } = props
  const className = isActive ? 'ss-section ss-section--is-active' : 'ss-section'

  return (
    <article ref={ref} className={`${className} pb-4`}>
      {title && (
        <div className="ss-section__header">
          <div className="ss-section__header-wrapper">
            <H4Styled
              as="h2"
              className="m-0"
              dangerouslySetInnerHTML={{ __html: title }}
            />
          </div>
        </div>
      )}

      {children}
    </article>
  )
})

SSpySection.propTypes = {
  /** Content of the section */
  children: PropTypes.node.isRequired,

  /** Flag to show active section or not */
  isActive: PropTypes.bool.isRequired,

  /** Title of the section */
  title: PropTypes.string,
}

SSpySection.defaultProps = {
  title: '',
}

export default SSpySection
